module.exports = "https://web-phone.apps.phone.com/static/media/NTR-Regular.e44d5d42.ttf";